import { NoPermissionState } from "@/components/common/no-permission-state";
import { isForbiddenError } from "@/lib/clinic-grants";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import {
  PageHeader,
  Input,
  Button,
  Skeleton,
  EmptyState,
} from "@/components/ui";
import {
  ContainerHeader,
  FormProvider,
  ProviderDataTable,
} from "@/components/common";
import { useFetchProvidersQuery } from "@/hooks";

export function Providers() {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

  const [search, setSearch] = useState<string>("");

  const { data: allProviderData, isLoading, error: listError } = useFetchProvidersQuery({
    search,
    page,
  });

  // SEC-GATES-02: a refusal from the list endpoint is stated, not shown as an empty list.
  if (isForbiddenError(listError)) return <NoPermissionState />;

  return (
    <section className="space-y-7">
      <div className="space-y-5">
        <PageHeader
          eyebrow="Clínica"
          title={t("LABEL.providers")}
          lede="Quem fornece os produtos e materiais usados nos procedimentos."
          actions={
            <FormProvider>
              <Button variant="petrol" size="lg" className="px-5">
                Criar
              </Button>
            </FormProvider>
          }
        />
        <ContainerHeader>
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type="search"
            aria-label="Pesquisar fornecedores"
            placeholder="Pesquisar"
            showError={false}
          />
        </ContainerHeader>
      </div>

      <div className="space-y-2">
        {!allProviderData || isLoading ? (
          <Skeleton className="w-full h-[500px]" />
        ) : allProviderData.items.length === 0 ? (
          // C-11: the screen entered the menu, so it says what it is for.
          <EmptyState
            title="Nenhum fornecedor cadastrado"
            description="Cadastre aqui quem fornece os produtos e materiais usados nos procedimentos, para vinculá-los às entradas do estoque."
            action={
              <FormProvider>
                <Button className="px-10">Criar</Button>
              </FormProvider>
            }
          />
        ) : (
          <ProviderDataTable data={allProviderData} />
        )}
      </div>
    </section>
  );
}
